/*
Ashraf 01/11/2023 2699710829 initial sub tabs render for audit list

*/
import React, {useContext} from 'react';
import SubTabsContent from './SubTabsContent';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {useLocation} from 'react-router';
import LandingPage from '../../../LandingPage';

const ClientAuditFieldList = ({tabValue, setTabValue, StepperFieldList}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = React.useState(0);
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = ['Client Audit Field List'];
  return (
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={value}
        handleTabChange={handleChange}
        allAntTabs={tabLabels}
      >
        <div className={`global-field-dash-board`}>
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                <SubTabsContent AuditFieldList={location.pathname === '/frameworks/audit-field-list'} setTabValue={setTabValue} StepperFieldList={StepperFieldList} />
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
};

export default ClientAuditFieldList;
